module.exports = __webpack_public_path__ + "img/mvp_teach_friends_register.71fa80cc.png";